import usePrevious from './usePrevious'

const useDidChange = value => {
  const previousValue = usePrevious(value)
  return value !== previousValue
}

export default useDidChange
